import { render, staticRenderFns } from "./Edit-demo.vue?vue&type=template&id=b85336fc&scoped=true"
import script from "./Edit-demo.vue?vue&type=script&lang=js"
export * from "./Edit-demo.vue?vue&type=script&lang=js"
import style0 from "./Edit-demo.vue?vue&type=style&index=0&id=b85336fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85336fc",
  null
  
)

export default component.exports